// extracted by mini-css-extract-plugin
export var infoItem = "_rz-2";
export var title = "_rz-0";
export var value = "_rz-1";